import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const GroupView = () => {
  const [startDate, setStartDate] = useState(moment("2020-01-01").format("YYYY-MM-DD")); // Earliest date
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [district, setDistrict] = useState("all");
  const [type, setType] = useState("all");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Group View - Calendar Services";

      // Set the initial start date to a very early date to include all records
      const earliestDate = moment("2020-01-01"); // Start from the year 2000
      const today = moment();
    
      setStartDate(earliestDate.format("YYYY-MM-DD"));
      setEndDate(today.format("YYYY-MM-DD"));

    // Initialize the date range picker
    $("#kt_daterangepicker_4").daterangepicker(
     {
          startDate: earliestDate,
          endDate: today,
          ranges: {
            "From the Beginning": [earliestDate, today], // Custom option to select all records
            Today: [today, today],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), today],
            "Last 30 Days": [moment().subtract(29, "days"), today],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
          },
      },
      (start, end) => {
        setStartDate(start.format("YYYY-MM-DD"));
        setEndDate(end.format("YYYY-MM-DD"));
        $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
      }
    );

    // Set initial display value
    $("#kt_daterangepicker_4").html(
      `${moment("2020-01-01").format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
    );
  }, []);

  useEffect(() => {
    fetchData();
  }, [startDate, endDate, district, type]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // const response = await axios.post("http://localhost:3036/groupview", {
        const response = await axios.post(`${API_BASE_URL}/groupview`, {

        startDate,
        endDate,
        district,
        type,
      });

      // Add serial numbers to each row
      const dataWithSlNo = response.data.map((item, index) => ({
        ...item,
        slNo: index + 1,
      }));

      // Calculate totals and append the totals row
      const totals = calculateTotals(dataWithSlNo);
      const dataWithTotalRow = [...dataWithSlNo, totals];
      setData(dataWithTotalRow);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const calculateTotals = (data) => {
    return {
      slNo: "Total",
      service: "",
      totalFreeUsers: data.reduce((sum, row) => sum + (row.totalFreeUsers || 0), 0),
      totalFreeLiveUsers: data.reduce((sum, row) => sum + (row.totalFreeLiveUsers || 0), 0),
      totalPaidUsers: data.reduce((sum, row) => sum + (row.totalPaidUsers || 0), 0),
      totalPaidLiveUsers: data.reduce((sum, row) => sum + (row.totalPaidLiveUsers || 0), 0),
      totalLive: data.reduce((sum, row) => sum + (row.totalLive || 0), 0),
      callCount: data.reduce((sum, row) => sum + (row.callCount || 0), 0),
      viewCount: data.reduce((sum, row) => sum + (row.viewCount || 0), 0),
    };
  };

  const columns = [
    { name: "SlNo", selector: (row) => row.slNo, sortable: true },
    { name: "Service's", selector: (row) => row.service, sortable: true },
    { name: "Total Free Users", selector: (row) => row.totalFreeUsers, sortable: true },
    { name: "Total Free Live Users", selector: (row) => row.totalFreeLiveUsers, sortable: true },
    { name: "Total Paid Users", selector: (row) => row.totalPaidUsers, sortable: true },
    { name: "Total Paid Live Users", selector: (row) => row.totalPaidLiveUsers, sortable: true },
    { name: "Total Live", selector: (row) => row.totalLive, sortable: true },
    { name: "Call Count", selector: (row) => row.callCount, sortable: true },
    { name: "View Count", selector: (row) => row.viewCount, sortable: true },
  ];

  return (
    <div className="max-w-7xl mx-auto mt-8 bg-white">
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">Group View Report</h2>

  <div className="mb-3">
             <div className="text-center mb-6 flex items-center space-x-2 justify-center">
                <div
                          id="kt_daterangepicker_4"
                          className="bg-white border px-4 py-2 inline-block rounded cursor-pointer"
                        >
                          {`${moment("2020-01-01").format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
                        </div>
 
               <svg
                 xmlns="http://www.w3.org/2000/svg"
                 className="h-5 w-5 text-gray-500"
                 fill="none"
                 viewBox="0 0 24 24"
                 stroke="currentColor"
               >
                 <path
                   strokeLinecap="round"
                   strokeLinejoin="round"
                   strokeWidth={2}
                   d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
                 />
               </svg>
             </div>
           </div>

      <DataTable
        columns={columns}
        data={data}
        progressPending={loading}
        pagination
        paginationPerPage={11}
        highlightOnHover
      />
    </div>
  );
};

export default GroupView;
